import gql from 'graphql-tag';

export default gql`
  query sessionLogin {
    me {
      mfaVerified
      mfaMethod
      mfaEnforced
    }
  }
`;
